(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carlie-featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carlie-product-carousel')) {
    customElements.define(
      'carlie-product-carousel',
      class CarlieProductCarousel extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('.carlie-featured-carousel__viewport');
          this.items = Array.from(this.querySelectorAll('.carlie-featured-carousel__item'));
          this.navigation = this.querySelector('.carlie-featured-carousel__navigation');
          this.previousButton = this.querySelector('.carlie-featured-carousel__arrow--previous');
          this.nextButton = this.querySelector('.carlie-featured-carousel__arrow--next');
          this.dots = Array.from(this.querySelectorAll('.carlie-featured-carousel__dot'));

          if (!this.viewport) return;
          if (!this.items.length) {
            this.hidden = true;
            return;
          }

          this.previousButton.addEventListener('click', () => this.goToPage(this.currentPage - 1));
          this.nextButton.addEventListener('click', () => this.goToPage(this.currentPage + 1));
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goToPage(index)));
          this.viewport.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
          this.viewport.addEventListener('keydown', (event) => this.onKeydown(event));

          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.viewport);
          this.refresh();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        refresh() {
          const itemWidth = this.items[0].getBoundingClientRect().width;
          const track = this.querySelector('.carlie-featured-carousel__track');
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          this.itemsPerPage = Math.max(1, Math.floor((this.viewport.clientWidth + gap + 1) / (itemWidth + gap)));
          this.pageCount = Math.ceil(this.items.length / this.itemsPerPage);
          const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);

          this.pageOffsets = Array.from({ length: this.pageCount }, (_, index) => {
            const item = this.items[Math.min(index * this.itemsPerPage, this.items.length - 1)];
            return Math.min(item.offsetLeft - this.items[0].offsetLeft, maximumScroll);
          });

          this.dots.forEach((dot, index) => {
            dot.hidden = index >= this.pageCount;
          });
          this.navigation.hidden = maximumScroll < 2;
          this.update();
        }

        requestUpdate() {
          if (this.updateFrame) return;
          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.update();
          });
        }

        update() {
          const currentOffset = this.viewport.scrollLeft;
          this.currentPage = this.pageOffsets.reduce((closestIndex, offset, index, offsets) => {
            return Math.abs(offset - currentOffset) < Math.abs(offsets[closestIndex] - currentOffset) ? index : closestIndex;
          }, 0);

          this.previousButton.disabled = this.currentPage === 0;
          this.nextButton.disabled = this.currentPage === this.pageCount - 1;
          this.dots.forEach((dot, index) => {
            if (index === this.currentPage) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        goToPage(index) {
          const targetPage = Math.max(0, Math.min(index, this.pageCount - 1));
          this.viewport.scrollTo({ left: this.pageOffsets[targetPage], behavior: 'smooth' });
        }

        onKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goToPage(this.currentPage + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlie-gift-idea"] && !Shopify.designMode) return;
  try {
    
  if (!window.carlieGiftIdeaBound) {
    window.carlieGiftIdeaBound = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-gift-add]');
      if (!button) return;

      const gift = button.closest('.carlie-gift-idea');
      const variants = [...gift.querySelectorAll('[data-variant-id]')].map((item) => item.dataset.variantId);
      const label = button.querySelector('span');
      const originalLabel = label.textContent;
      button.disabled = true;
      label.textContent = button.dataset.loadingLabel;

      try {
        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: variants.map((id) => ({
              id: Number(id),
              quantity: 1,
              properties: { _gaveide: button.dataset.giftHandle }
            }))
          })
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || button.dataset.errorLabel);
        }

        window.location.assign(button.dataset.cartUrl);
      } catch (error) {
        label.textContent = error.message || button.dataset.errorLabel;
        window.setTimeout(() => {
          label.textContent = originalLabel;
        }, 3000);
      } finally {
        button.disabled = false;
        if (label.textContent === button.dataset.loadingLabel) label.textContent = originalLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlie-inspiration-side"] && !Shopify.designMode) return;
  try {
    

if (!window.carlieInspirationCartBound) {
  window.carlieInspirationCartBound = true;

  const showCarlieCartStatus = (message) => {
    let status = document.querySelector('[data-carlie-cart-status]');

    if (!status) {
      status = document.createElement('div');
      status.className = 'carlie-cart-status';
      status.dataset.carlieCartStatus = '';
      status.setAttribute('role', 'status');
      document.body.appendChild(status);
    }

    status.textContent = message;
    status.hidden = false;

    window.clearTimeout(status.carlieHideTimer);

    status.carlieHideTimer = window.setTimeout(() => {
      status.hidden = true;
    }, 2500);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-carlie-ajax-cart]');

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const buttonLabel = button.querySelector('span');
    const originalLabel = buttonLabel.textContent;

    const cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    const formData = new FormData(form);

    button.disabled = true;
    buttonLabel.textContent = 'Tilføjer…';

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );

      formData.append(
        'sections_url',
        window.location.pathname
      );
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          'Produktet kunne ikke tilføjes.'
        );
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(result);
      } else {
        showCarlieCartStatus('Tilføjet til kurven');
      }

    } catch (error) {

      showCarlieCartStatus(
        error.message ||
        'Prøv igen.'
      );

    } finally {

      button.disabled = false;
      buttonLabel.textContent = originalLabel;

    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
